/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./copy-clipboard.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/common";
import * as i3 from "./copy-clipboard.component";
import * as i4 from "../services/copy-clipboard.service";
var styles_CopyClipboardComponent = [i0.styles];
var RenderType_CopyClipboardComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CopyClipboardComponent, data: {} });
export { RenderType_CopyClipboardComponent as RenderType_CopyClipboardComponent };
export function View_CopyClipboardComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "i", [["class", "fa"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.copyContent() !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), i1.ɵdid(1, 278528, null, 0, i2.NgClass, [i1.IterableDiffers, i1.KeyValueDiffers, i1.ElementRef, i1.Renderer2], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "fa"; var currVal_1 = _co.iconClass; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
export function View_CopyClipboardComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dac-copy-clipboard", [], null, null, null, View_CopyClipboardComponent_0, RenderType_CopyClipboardComponent)), i1.ɵdid(1, 638976, null, 0, i3.CopyClipboardComponent, [i4.CopyClipboardService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CopyClipboardComponentNgFactory = i1.ɵccf("dac-copy-clipboard", i3.CopyClipboardComponent, View_CopyClipboardComponent_Host_0, { content: "content", iconClass: "iconClass" }, {}, []);
export { CopyClipboardComponentNgFactory as CopyClipboardComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/shared/copy-clipboard/copy-clipboard.component.ngfactory.js.pre-build-optimizer.js